// Shared links and the smooth scroll used by the nav and the hero.
export const GITHUB_URL = "https://www.github.com/andrewakrise";
export const LINKEDIN_URL = "https://www.linkedin.com/in/andrewrise/";
export const EMAIL = "andrewakrise@gmail.com";

export const scrollToId = (id) => (e) => {
  e?.preventDefault?.();
  document.getElementById(id)?.scrollIntoView?.({ behavior: "smooth", block: "start" });
};
